<template>
  <div class="sign">
    <van-form @submit="onSubmit">
      <van-field
        v-model="cun"
        name="所在地"
        label="所在地："
        placeholder="点击选择所在地"
        readonly
        @click="showPicker = true"
        :rules="[{ required: true, message: '请选择所在地' }]"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <van-field
        v-model="true_name"
        name="姓名"
        label="姓名："
        placeholder="姓名"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-field
        v-model="telephone"
        name="联系方式"
        label="联系方式："
        placeholder="联系方式"
        :rules="[
          { required: true, validator, message: '请输入正确的联系方式' },
        ]"
      />
      <div style="margin: 16px">
        <button type="submit" class="sub-btn">
          <img
            src="https://i.tmuyun.com/webpic/W0202203/W020220328/W020220328554726733019.png"
            alt=""
          />
        </button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { Form, Field, Toast } from "vant";
import { addJfwmUser, hasUser } from "@/api/jfwm";
import { isPhone } from "@/utils/common";

export default {
  name: "sign",
  data() {
    return {
      columns: [
        "山马村",
        "山头赵村",
        "南山闸村",
        "南山村",
        "九份村",
        "六份村",
        "琅岙村",
        "麻车村",
        "花桥村",
        "横塘村",
        "万昌村",
        "后陈村",
        "东普村",
        "石粘村",
        "沿江居",
      ],
      cun: "",
      true_name: "",
      telephone: "",
      doing: false,
      showPicker: false,
    };
  },
  created() {
    // 判断是否登记过
    hasUser().then((res) => {
      const data = res.data;
      if (data.has_user == 1) {
        this.$router.push("/jfwm/upload");
      }
    });
  },
  methods: {
    validator(val) {
      return isPhone(val);
    },
    onConfirm(value, index) {
      // console.log(index);
      this.cun = value;
      this.showPicker = false;
    },
    onSubmit() {
      let self = this;

      if (this.doing) return false;
      this.doing = true;

      Toast.loading({
        message: "提交中...",
        forbidClick: true,
      });

      const data = {
        cun: this.cun,
        true_name: this.true_name,
        telephone: this.telephone,
      };
      addJfwmUser(data)
        .then((res) => {
          console.log(res);
          // this.doing = false;
          Toast.success({
            message: "登记成功",
            onClose() {
              self.$router.push("/jfwm/upload");
            },
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.sign {
  height: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .van-field {
    background-color: #54bdc1;
    margin: 20px 0;
    border-radius: 15px;
    box-shadow: 0px 7px 1px #c1f4f7;
    // color: #fff !important;
    /deep/ .van-field__label,
    .van-field__value {
      color: #fff !important;
    }
  }
  .sub-btn {
    background-color: transparent;
    border: none;
    width: 50vw;
    img {
      width: 100%;
    }
  }
}
</style>